module.exports = __webpack_public_path__ + "static/media/westhill-longrange.e41b7f21.jpg";